const actions = {
  SAVE_QUOTES_DATA: "SAVE_QUOTES_DATA",

  saveQuotesData: (data) => {
    return {
      type: actions.SAVE_QUOTES_DATA,
      quotesData: data
    };
  }
};

export default actions;
